import React, { useEffect, useState } from 'react';
import { Shield, Zap, Mail } from 'lucide-react';
export function ProductHero() {
  const [viewers, setViewers] = useState(100);
  useEffect(() => {
    const startViewerCount = () => {
      let count = Math.floor(Math.random() * (120 - 80 + 1) + 80);
      setViewers(count);
      const interval = setInterval(() => {
        let increment = Math.floor(Math.random() * 3) - 1;
        count += increment;
        if (count < 60) count = 60;
        setViewers(count);
      }, 4500);
      return interval;
    };
    const interval = startViewerCount();
    return () => clearInterval(interval);
  }, []);
  return <section className="py-[30px] px-0" data-id="element-207">
      <div className="container max-w-[500px] mx-auto px-[15px]" data-id="element-208">
        <div className="mx-auto my-[20px] overflow-hidden shadow-[0_10px_20px_rgba(0,0,0,0.08)] rounded-[8px] max-w-full" data-id="element-209">
          <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770505603962.png" alt="La Biblia del Café" className="w-full block rounded-[8px]" data-id="element-210" />
        </div>

        <div className="text-center mx-auto my-[25px] mb-[15px]" data-id="element-211">
          <p className="text-[11px] font-[600] text-[#6B7280] uppercase" data-id="element-212">
            +1.200 DESCARGAS
          </p>
          <h1 className="text-[22px] leading-[1.4] font-[700] text-[#111827] font-['Montserrat']" data-id="element-213">
            📦 La Biblia del Café — Método BÍBLICO™
          </h1>
        </div>

        <div className="bg-gradient-to-br from-[#111827] to-[#1F2937] rounded-[8px] p-[20px] mx-auto my-[20px] border border-[#8B4513] max-w-full" data-id="element-214">
          <div className="flex flex-col items-center gap-[3px]" data-id="element-215">
            <div className="text-[18px] line-through text-[#ccc]" data-id="element-216">$19.99</div>
            <div className="text-[38px] text-[#D2B48C] font-[800]" data-id="element-217">
              $6.37 USD
            </div>
            <div className="bg-gradient-to-br from-[#8B4513] to-[#D2B48C] text-white px-[14px] py-[5px] rounded-[50px] font-bold text-[13px] uppercase mt-[10px]" data-id="element-218">
              AHORRO $13.62
            </div>
          </div>
          <div className="flex justify-around mt-[15px] pt-[15px] border-t border-[#654321] text-[#ddd] text-[12px]" data-id="element-219">
            <div className="flex items-center gap-1" data-id="element-220">
              <Shield className="w-3 h-3" data-id="element-221" /> Pago Seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-222">
              <Zap className="w-3 h-3" data-id="element-223" /> Acceso Instantáneo
            </div>
          </div>
        </div>

        <div className="max-w-[500px] mx-auto my-[25px] mb-[10px] flex flex-col gap-[12px]" data-id="element-224">
          <div className="bg-[#111827] text-white font-[700] p-[12px] rounded-[8px] text-[16px] text-center" data-id="element-225">
            <strong data-id="element-226">
              <span className="viewer-count" data-id="element-227">{viewers}</span> personas
            </strong>{' '}
            están viendo esta oferta
          </div>
          <div className="bg-gradient-to-br from-[#EF4444] to-[#be123c] text-white font-[700] p-[12px] rounded-[8px] text-[16px] text-center flex items-center justify-center gap-[10px]" data-id="element-228">
            <span className="w-[12px] h-[12px] bg-white rounded-full animate-pulse-red" data-id="element-229"></span>{' '}
            ¡Últimos <strong data-id="element-230">5 Cupos</strong> en Oferta!
          </div>
        </div>

        <a className="block w-full bg-gradient-to-br from-[#10B981] to-[#16a34a] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(139,69,19,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(139,69,19,0.5)] transition-all duration-400" href="#elige-tu-plan" data-id="element-231">
          ¡DESCARGAR AHORA MISMO!
        </a>

        <div className="flex items-center justify-center gap-[12px] bg-white rounded-[8px] p-[12px] mx-auto my-[10px] shadow-[0_4px_10px_rgba(0,0,0,0.05)] max-w-full" data-id="element-232">
          <div className="text-[24px] text-[#8B4513]" data-id="element-233">
            <Mail data-id="element-234" />
          </div>
          <div data-id="element-235">
            <h3 className="text-[15px] color-[#111827] font-[700] font-['Montserrat']" data-id="element-236">
              Acceso inmediato
            </h3>
            <p className="text-[12px]" data-id="element-237">Vía correo electrónico </p>
          </div>
        </div>
      </div>
    </section>;
}